import moment from "moment";

// ===========================================================================
// Dummy data for forecast APIs.
// Used when USE_DUMMY_DATA = true in forecastApi.js. Safe to keep around
// even after real APIs are wired in - simply flip the flag to disable.
// ===========================================================================

export const fetchCMOMembersResponse = {
  status: true,
  CMOMembersWithId: [
    { organization_id: 101, organization_name: "Acme Manufacturing" },
    { organization_id: 102, organization_name: "Bright Pharma CMO" },
    { organization_id: 103, organization_name: "Coastal Contract Mfg" },
  ],
};

export const fetchSponsorsForCMOResponse = {
  status: true,
  data: [
    { sponsorOrgID: 201, sponsorOrgName: "Sponsor Alpha Pharma" },
    { sponsorOrgID: 202, sponsorOrgName: "Sponsor Beta Health" },
    { sponsorOrgID: 203, sponsorOrgName: "Sponsor Gamma Bio" },
  ],
};

export const fetchBrandValuesResponse = {
  status: true,
  data: [
    { brand: "BrandOne 200mg" },
    { brand: "BrandTwo 500mg" },
    { brand: "BrandThree Syrup" },
  ],
};

export const fetchMfgPlantsResponse = {
  status: true,
  MfgPlantsDetails: [
    { aslNumber: "ASL-001", mfgPlantShortName: "Plant Mumbai" },
    { aslNumber: "ASL-002", mfgPlantShortName: "Plant Hyderabad" },
    { aslNumber: "ASL-003", mfgPlantShortName: "Plant Pune" },
  ],
};

export const fetchAllFiltersResponse = {
  status: true,
  data: {
    // forecastDashboard: {
    //   cmoOrgID: 101,
    //   cmoLabel: "Acme Manufacturing",
    //   sponsorOrgID: 201,
    //   sponsorLabel: "Sponsor Alpha Pharma",
    //   brand: "BrandOne 200mg",
    //   aslNumberList: [],
    //   startMonth: moment().startOf("month").format("YYYY-MM-DD"),
    //   endMonth: moment()
    //     .add(12, "months")
    //     .startOf("month")
    //     .format("YYYY-MM-DD"),
    // },
  },
};

export const saveFiltersResponse = { status: true };
export const updateForecastDetailsResponse = { status: true };

const dummyProducts = [
  { collabrixProductID: 1, productCode: "MAT-1001", productDescription: "Tablet 200mg Strip", uom: "EA" },
  { collabrixProductID: 2, productCode: "MAT-1002", productDescription: "Tablet 500mg Strip", uom: "EA" },
  { collabrixProductID: 3, productCode: "MAT-1003", productDescription: "Syrup Bottle 100ml", uom: "BOT" },
  { collabrixProductID: 4, productCode: "MAT-1004", productDescription: "Capsule 250mg Blister", uom: "EA" },
  { collabrixProductID: 5, productCode: "MAT-1005", productDescription: "Injection Vial 5ml", uom: "VIAL" },
  { collabrixProductID: 6, productCode: "MAT-1006", productDescription: "Ointment Tube 30g", uom: "TUB" },
  { collabrixProductID: 7, productCode: "MAT-1007", productDescription: "Eye Drops Bottle 10ml", uom: "BOT" },
  { collabrixProductID: 8, productCode: "MAT-1008", productDescription: "Nasal Spray 20ml", uom: "BOT" },
  { collabrixProductID: 9, productCode: "MAT-1009", productDescription: "Capsule 100mg Strip", uom: "EA" },
  { collabrixProductID: 10, productCode: "MAT-1010", productDescription: "Tablet 1000mg Strip", uom: "EA" },
  { collabrixProductID: 11, productCode: "MAT-1011", productDescription: "Suspension Bottle 200ml", uom: "BOT" },
  { collabrixProductID: 12, productCode: "MAT-1012", productDescription: "Cream Tube 50g", uom: "TUB" },
  { collabrixProductID: 13, productCode: "MAT-1013", productDescription: "Powder Sachet 5g", uom: "SAC" },
  { collabrixProductID: 14, productCode: "MAT-1014", productDescription: "Gel Tube 25g", uom: "TUB" },
  { collabrixProductID: 15, productCode: "MAT-1015", productDescription: "Inhaler 200 Doses", uom: "PCS" },
  { collabrixProductID: 16, productCode: "MAT-1016", productDescription: "Patch Transdermal 5mg", uom: "EA" },
  { collabrixProductID: 17, productCode: "MAT-1017", productDescription: "Suppository 500mg", uom: "EA" },
  { collabrixProductID: 18, productCode: "MAT-1018", productDescription: "Lozenge 10mg Strip", uom: "EA" },
  { collabrixProductID: 19, productCode: "MAT-1019", productDescription: "Ampoule 2ml Injection", uom: "AMP" },
  { collabrixProductID: 20, productCode: "MAT-1020", productDescription: "Tablet 750mg Strip", uom: "EA" },
  { collabrixProductID: 21, productCode: "MAT-1021", productDescription: "Liquid Concentrate 50ml", uom: "BOT" },
  { collabrixProductID: 22, productCode: "MAT-1022", productDescription: "Capsule 400mg Blister", uom: "EA" },
  { collabrixProductID: 23, productCode: "MAT-1023", productDescription: "Drops Oral 30ml", uom: "BOT" },
  { collabrixProductID: 24, productCode: "MAT-1024", productDescription: "Powder for Injection 1g", uom: "VIAL" },
  { collabrixProductID: 25, productCode: "MAT-1025", productDescription: "Tablet Effervescent 500mg", uom: "EA" },
  { collabrixProductID: 26, productCode: "MAT-1026", productDescription: "Lotion Bottle 150ml", uom: "BOT" },
  { collabrixProductID: 27, productCode: "MAT-1027", productDescription: "Shampoo Medicated 100ml", uom: "BOT" },
  { collabrixProductID: 28, productCode: "MAT-1028", productDescription: "Tablet Chewable 125mg Strip", uom: "EA" },
  { collabrixProductID: 29, productCode: "MAT-1029", productDescription: "Serum Vial 10ml", uom: "VIAL" },
  { collabrixProductID: 30, productCode: "MAT-1030", productDescription: "Sachet Oral Rehydration 21g", uom: "SAC" },
];

const monthsBetween = (start, end) => {
  const list = [];
  let cur = moment(start, "YYYY-MM-DD").startOf("month");
  const last = moment(end, "YYYY-MM-DD").startOf("month");
  while (cur.isSameOrBefore(last, "month")) {
    list.push(cur.format("YYYY-MM-DD"));
    cur = cur.clone().add(1, "month");
  }
  return list;
};

const baseQty = (productIdx, monthIdx) =>
  1000 + productIdx * 250 + monthIdx * 50;

export const buildFetchForecastsResponse = (payload) => {
  const start =
    (payload && payload.startMonth) ||
    moment().startOf("month").format("YYYY-MM-DD");
  const end =
    (payload && payload.endMonth) ||
    moment().add(5, "months").startOf("month").format("YYYY-MM-DD");
  const months = monthsBetween(start, end);
  const cmoOrgID = (payload && payload.cmoOrgID) || 101;
  const sponsorOrgID = (payload && payload.sponsorOrgID) || 201;
  const syncId = (payload && payload.collabrixForecastSyncID) || 5001;
  const rawPageNumber = payload && payload.pageNumber;
  const rawPageSize = payload && payload.pageSize;
  const fetchAll = rawPageNumber === 0 && rawPageSize === 0;
  const pageNumber = fetchAll ? 1 : rawPageNumber || 1;
  const pageSize = fetchAll ? dummyProducts.length : rawPageSize || 10;

  const totalNoOfRecords = dummyProducts.length;
  const noOfPages = fetchAll ? 1 : Math.ceil(totalNoOfRecords / pageSize);
  const startIndex = fetchAll ? 0 : (pageNumber - 1) * pageSize;
  const paginatedProducts = fetchAll
    ? dummyProducts
    : dummyProducts.slice(startIndex, startIndex + pageSize);

  let detailIdSeq = 1;
  const forecastDetailsList = [];
  paginatedProducts.forEach((p, pi) => {
    months.forEach((m, mi) => {
      const qty = baseQty(pi, mi);
      forecastDetailsList.push({
        collabrixForecastDetailID: detailIdSeq++,
        collabrixForecastSyncID: syncId,
        collabrixProductID: p.collabrixProductID,
        productCode: p.productCode,
        productDescription: p.productDescription,
        uom: p.uom,
        forecastMonth: m,
        quantity: qty,
        cmoOrgID,
        sponsorOrgID,
        exceedsLowLimit: pi === 0 && mi === 1,
        exceedsHighLimit: pi === 1 && mi === 2,
      });
    });
  });

  return {
    status: true,
    data: {
      forecastDetailsList,
      totalNoOfRecords,
      noOfPages,
      pageNumber,
      pageSize,
    },
  };
};

export const fetchForecastHistoryResponse = {
  status: true,
  data: {
    forecastDataList: [
      {
        collabrixForecastSyncID: 5003,
        forecastSyncDate: moment().subtract(1, "day").toISOString(),
      },
      {
        collabrixForecastSyncID: 5002,
        forecastSyncDate: moment().subtract(7, "days").toISOString(),
      },
      {
        collabrixForecastSyncID: 5001,
        forecastSyncDate: moment().subtract(30, "days").toISOString(),
      },
    ],
  },
};

export const fetchForecastChatDataResponse = {
  status: true,
  data: {
    forecastChatData: [
      {
        chatData: "Forecast looks aligned with last quarter's plan.",
        chatSenderEmail: "sponsor.user@example.com",
        senderLegalName: "Priya Sharma",
        chatTimeStamp: moment().subtract(2, "hours").toISOString(),
        collaboratorTypeID: 1,
      },
      {
        chatData: "Acknowledged. We will process this batch on priority.",
        chatSenderEmail: "cmo.user@example.com",
        senderLegalName: "Rahul Verma",
        chatTimeStamp: moment().subtract(1, "hours").toISOString(),
        collaboratorTypeID: 2,
      },
    ],
  },
};

export const buildAddForecastChatDataResponse = (payload) => ({
  status: true,
  data: {
    chatTimeStamp: (payload && payload.chatTimeStamp) || new Date().toISOString(),
  },
});
